import { TirePartItem } from "../../../../queries/useSearchTiresByVehicle";
import { WheelPartItem } from "../../../../queries/useSearchWheelsByVehicle";
import { useCart } from "../../../../stores/hooks/useCart";
import { AnyOrderItem, CartState } from "../../../../stores/slices/cartSlice";

const findOrderItemInCart = (
  cart: CartState,
  itemId: null | string
): AnyOrderItem | null =>
  cart?.orderItemList.find((item) => item.itemId === itemId) || null;

type Props = {
  isStaggered: boolean;
  tire: TirePartItem;
  wheel: WheelPartItem;
};

export const useCartItems = ({
  isStaggered,
  tire,
  wheel,
}: Props): (AnyOrderItem | null)[] => {
  const cart = useCart();

  const primaryTireItem = findOrderItemInCart(
    cart,
    tire.partDetails.primaryPart.itemId || null
  );

  const wheelOrderItem = findOrderItemInCart(
    cart,
    wheel.partDetails.primaryPart.itemId || null
  );

  if (!primaryTireItem || !wheelOrderItem) {
    return [];
  }

  const secondaryItems = isStaggered
    ? tire.partDetails.secondaryParts
        .map((part) => findOrderItemInCart(cart, part.itemId || null))
        .slice(0, 1)
    : [];

  return [primaryTireItem, ...secondaryItems, wheelOrderItem];
};
